(function () {
  function initEditionSelector(selector) {
    if (!selector || selector.dataset.scEditionReady === 'true') return;
    selector.dataset.scEditionReady = 'true';

    var details = selector.querySelector('[data-sc-edition-details]');
    var summaryText = selector.querySelector('[data-sc-edition-summary]');
    var choices = selector.querySelectorAll('[data-sc-edition-choice]');
    var ltdGallery = selector.querySelector('[data-sc-edition-gallery]');
    var travelGallery = selector.querySelector('[data-sc-travel-gallery]');

    var productDetails = selector.closest('.product-details');
    var productInformation = selector.closest('.product-information');
    if (!productDetails || !productInformation) return;

    var mediaWrap = productInformation.querySelector('.product-information__media');
    var nativeGallery = mediaWrap ? mediaWrap.querySelector('media-gallery') : null;
    if (travelGallery && mediaWrap) {
      mediaWrap.appendChild(travelGallery);
      travelGallery.style.cssText = 'display:block;width:100%;min-width:0;overflow:visible';
      var travelSlides = Array.from(travelGallery.children);
      var travelThumbs = document.createElement('div');
      travelThumbs.setAttribute('role', 'group');
      travelThumbs.setAttribute('aria-label', 'Travel product images');
      travelThumbs.style.cssText = 'display:flex;flex-wrap:wrap;gap:8px;padding:12px 0;min-width:0';
      travelSlides.forEach(function(slide, index) {
        slide.hidden = index !== 0;
        var sourceImage = slide.querySelector('img');
        if (!sourceImage) return;
        var button = document.createElement('button');
        button.type = 'button';
        button.setAttribute('aria-label', 'Show Travel image ' + (index + 1));
        button.setAttribute('aria-pressed', index === 0 ? 'true' : 'false');
        button.style.cssText = 'flex:0 0 64px;width:64px;height:64px;padding:2px;border:1px solid ' + (index === 0 ? '#171717' : '#ddd') + ';border-radius:6px;background:white;cursor:pointer';
        var thumbnail = sourceImage.cloneNode(true);
        thumbnail.removeAttribute('srcset');
        thumbnail.removeAttribute('sizes');
        var thumbnailUrl = new URL(sourceImage.src, window.location.href);
        thumbnailUrl.searchParams.set('width', '160');
        thumbnail.src = thumbnailUrl.href;
        thumbnail.style.cssText = 'display:block;width:100%;height:100%;object-fit:contain';
        button.appendChild(thumbnail);
        button.addEventListener('click', function() {
          travelSlides.forEach(function(item, i) { item.hidden = i !== index; });
          Array.from(travelThumbs.children).forEach(function(item, i) {
            item.setAttribute('aria-pressed', i === index ? 'true' : 'false');
            item.style.borderColor = i === index ? '#171717' : '#ddd';
          });
        });
        travelThumbs.appendChild(button);
      });
      travelGallery.appendChild(travelThumbs);
    }

    if (ltdGallery && mediaWrap && ltdGallery.parentElement !== mediaWrap) {
      mediaWrap.appendChild(ltdGallery);
    }

    var productForm = productDetails.querySelector('.buy-buttons-block product-form-component');
    var variantInput = productForm
      ? productForm.querySelector('input[name="id"][ref="variantId"], input[name="id"]')
      : null;
    var addToCartContainer = productForm ? productForm.querySelector('add-to-cart-component') : null;
    var addToCartButton = addToCartContainer
      ? addToCartContainer.querySelector('[ref="addToCartButton"], button[name="add"]')
      : null;
    var acceleratedCheckout = productForm
      ? productForm.querySelector('[ref="acceleratedCheckoutButtonContainer"]')
      : null;
    var localPickup = productDetails.querySelector('local-pickup');
    var gift = productForm ? productForm.querySelector('[data-sc-gift]') : null;
    var limitedGift = productForm ? productForm.querySelector('[data-sc-ltd-gift]') : null;

    var acceleratedWasHidden = acceleratedCheckout ? acceleratedCheckout.hidden : true;
    var pickupWasHidden = localPickup ? localPickup.hidden : true;

    var data = {
      mainline: {
        productId: selector.dataset.mainlineProductId || '',
        variantId: selector.dataset.mainlineVariantId || '',
        url: selector.dataset.mainlineUrl || window.location.pathname,
        available: selector.dataset.mainlineAvailable === 'true',
        media: selector.dataset.mainlineMediaUrl || ''
      },
      limited: {
        productId: selector.dataset.ltdProductId || '',
        variantId: selector.dataset.ltdVariantId || '',
        url: selector.dataset.ltdUrl || '',
        available: selector.dataset.ltdAvailable === 'true',
        media: selector.dataset.ltdMediaUrl || ''
      }
    };

    var currentEdition = 'mainline';
    data.travel = {
      productId: selector.dataset.travelProductId,
      variantId: selector.dataset.travelVariantId,
      url: selector.dataset.travelUrl,
      available: selector.dataset.travelAvailable === 'true',
      media: selector.dataset.travelMediaUrl
    };
    var prices = {mainline:selector.dataset.mainlinePrice,limited:selector.dataset.ltdPrice,travel:selector.dataset.travelPrice};
    function selectedProduct(edition) {
      var selected = data[edition];
      var activeGift = edition === 'mainline' ? gift : edition === 'limited' ? limitedGift : null;
      if (activeGift) {
        var choice = activeGift.querySelector('input:checked');
        return Object.assign({}, selected, {variantId:choice ? choice.dataset.giftVariant : '',productId:activeGift.dataset.productId,available:!!choice && !choice.disabled});
      }
      return selected;
    }

    function updateChoiceState(edition) {
      choices.forEach(function (choice) {
        var active = choice.dataset.scEditionChoice === edition;
        choice.classList.toggle('is-current', active);
        choice.setAttribute('aria-current', active ? 'true' : 'false');
        var check = choice.querySelector('.scentality-edition-selector__check');
        if (check) check.style.visibility = active ? 'visible' : 'hidden';
      });
    }

    function updateCollectionPill(edition) {
      productDetails.querySelectorAll('span').forEach(function (el) {
        var text = el.textContent.trim();
        if (text === 'Mainline Collection' || text === 'Limited Edition' || text === 'Travel Atomizer') {
          if (el.closest('.scentality-edition-selector')) return;
          el.textContent = edition === 'travel' ? 'Travel Atomizer' : edition === 'limited' ? 'Limited Edition' : 'Mainline Collection';
        }
      });
    }

    function updateUrl(edition) {
      try {
        var url = new URL(window.location.href);
        var mainline = new URL(data.mainline.url, window.location.origin);
        url.pathname = mainline.pathname;
        url.searchParams.delete('variant');
        if (edition !== 'mainline') url.searchParams.set('edition', edition);
        else url.searchParams.delete('edition');
        window.history.replaceState({}, '', url.pathname + url.search + url.hash);
      } catch (e) {}
    }

    function applyNativeFormProduct(edition) {
      if (!productForm || !variantInput) return;

      var selected = selectedProduct(edition);
      if (!selected || !selected.variantId) {
        if (addToCartButton) addToCartButton.setAttribute('disabled','disabled');
        if (acceleratedCheckout) acceleratedCheckout.hidden = true;
        return;
      }

      variantInput.value = selected.variantId;
      variantInput.setAttribute('value', selected.variantId);
      productForm.dataset.productId = selected.productId;
      productForm.dataset.productUrl = selected.url;

      if (addToCartContainer && selected.media) {
        addToCartContainer.dataset.productVariantMedia = selected.media;
      }

      if (addToCartButton) {
        if (selected.available) addToCartButton.removeAttribute('disabled');
        else addToCartButton.setAttribute('disabled', 'disabled');
      }

      if (acceleratedCheckout) {
        acceleratedCheckout.hidden = gift || edition !== 'mainline' ? true : acceleratedWasHidden;
      }

      if (localPickup) {
        localPickup.hidden = edition !== 'mainline' ? true : pickupWasHidden;
      }
    }

    function setEdition(edition, syncUrl) {
      if (edition === 'travel' && !data.travel.variantId) edition = 'mainline';
      if (edition === 'limited' && (!data.limited.variantId || !data.limited.available)) {
        edition = 'mainline';
      }

      currentEdition = edition;
      if (gift) { gift.hidden = edition !== 'mainline'; gift.disabled = edition !== 'mainline'; }
      if (limitedGift) { limitedGift.hidden = edition !== 'limited'; limitedGift.disabled = edition !== 'limited'; }
      var limited = edition === 'limited';

      productInformation.dataset.scEditionState = edition;

      if (nativeGallery) {
        nativeGallery.setAttribute('aria-hidden', edition !== 'mainline' ? 'true' : 'false');
      }
      if (ltdGallery) {
        ltdGallery.hidden = !limited;
        ltdGallery.setAttribute('aria-hidden', limited ? 'false' : 'true');
      }

      applyNativeFormProduct(edition);
      if (travelGallery) travelGallery.hidden = edition !== 'travel';
      productDetails.querySelectorAll('product-price .price, [class^="ai-product-price__amount-"]').forEach(function(el) { if (prices[edition]) el.textContent = prices[edition]; });
      productDetails.querySelectorAll('[class^="ai-product-price__label-"]').forEach(function(el) { el.textContent = edition === 'travel' ? '10ML | TRAVEL ATOMIZER' : '50ML | 1.7 FL.OZ'; });
      productDetails.querySelectorAll('div').forEach(function(el) { if (el.children.length === 0 && ['50ml EDP','10ml EDP'].includes(el.textContent.trim())) el.textContent = edition === 'travel' ? '10ml EDP' : '50ml EDP'; });
      productDetails.querySelectorAll('product-price .installments').forEach(function(el) { el.hidden = edition !== 'mainline'; });

      if (summaryText) summaryText.textContent = edition === 'travel' ? 'Travel 10ml' : limited ? 'Limited Edition' : 'Mainline';
      updateChoiceState(edition);
      updateCollectionPill(edition);

      if (details) details.open = false;
      if (syncUrl) updateUrl(edition);
    }

    choices.forEach(function (choice) {
      choice.addEventListener('click', function (event) {
        var edition = choice.dataset.scEditionChoice;
        if (!edition) return;

        if (!productForm || !variantInput) {
          return;
        }

        event.preventDefault();
        event.stopPropagation();
        setEdition(edition, true);
      });
    });

    if (productForm && variantInput) {
      productForm.addEventListener(
        'submit',
        function () {
          var selected = selectedProduct(currentEdition);
          if (!selected || !selected.variantId) return;
          variantInput.value = selected.variantId;
          variantInput.setAttribute('value', selected.variantId);
          productForm.dataset.productId = selected.productId;
          productForm.dataset.productUrl = selected.url;
        },
        true
      );
    }

    if (ltdGallery) {
      var slides = ltdGallery.querySelectorAll('[data-sc-edition-slide]');
      var thumbs = ltdGallery.querySelectorAll('[data-sc-edition-thumb]');
      var previous = ltdGallery.querySelector('[data-sc-edition-prev]');
      var next = ltdGallery.querySelector('[data-sc-edition-next]');
      var activeIndex = 0;

      function showSlide(index) {
        if (!slides.length) return;
        if (index < 0) index = slides.length - 1;
        if (index >= slides.length) index = 0;
        activeIndex = index;

        slides.forEach(function (slide, i) {
          slide.classList.toggle('is-active', i === activeIndex);
        });
        thumbs.forEach(function (thumb, i) {
          thumb.classList.toggle('is-active', i === activeIndex);
        });
      }

      thumbs.forEach(function (thumb, i) {
        thumb.addEventListener('click', function (event) {
          event.preventDefault();
          event.stopPropagation();
          showSlide(i);
        });
      });

      if (previous) {
        previous.addEventListener('click', function (event) {
          event.preventDefault();
          event.stopPropagation();
          showSlide(activeIndex - 1);
        });
      }

      if (next) {
        next.addEventListener('click', function (event) {
          event.preventDefault();
          event.stopPropagation();
          showSlide(activeIndex + 1);
        });
      }
    }

    var params = new URLSearchParams(window.location.search);
    if (gift) gift.addEventListener('change', function() { applyNativeFormProduct(currentEdition); });
    if (limitedGift) limitedGift.addEventListener('change', function() { applyNativeFormProduct(currentEdition); });
    var initialEdition =
      params.get('edition') === 'travel' ? 'travel' : params.get('edition') === 'limited' || selector.dataset.pageEdition === 'limited'
        ? 'limited'
        : 'mainline';

    setEdition(initialEdition, selector.dataset.pageEdition === 'limited');
  }

  function initAll() {
    document.querySelectorAll('[data-sc-edition-selector]').forEach(initEditionSelector);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', initAll);
})();
